import React from "react";
import LegalDocumentLayout from "./LegalDocumentLayout";

export default function CookiePolicy() {
  return (
    <LegalDocumentLayout title="Cookie policy">
      <h2>Summary</h2>
      <p>
        Cookies and similar technologies help this website keep you signed in, remember cart and session information,
        protect checkout, and understand how the website is used.
      </p>

      <h2>Required cookies</h2>
      <p>
        Required cookies support account sessions, security, checkout, cart storage, and your cookie-consent choice. The
        website may not work correctly if these cookies are blocked.
      </p>

      <h2>Optional / analytics flavour</h2>
      <p>
        With your consent, analytics or advertising services may use cookies or similar identifiers to measure traffic and
        campaign performance. These services may process data according to their own privacy policies.
      </p>

      <h2>Managing preferences</h2>
      <p>
        You can accept or refuse optional cookies through the cookie banner where available. You can also delete or block
        cookies in your browser settings, although doing so may sign you out or reset saved preferences.
      </p>

      <h2>Updates</h2>
      <p>
        We may update this policy when our website or service providers change. The latest version will remain available on
        this page.
      </p>
    </LegalDocumentLayout>
  );
}
